import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/dashboard/balance/current-assets")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
